module.exports = __webpack_public_path__ + "images/db-logos/azure_kusto.png";